import React from 'react';

export const IconCaret =() => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="#fff" stroke="#707070" strokeWidth="1" opacity="0"><rect width="16" height="16" stroke="none"/><rect x="0.5" y="0.5" width="15" height="15" fill="none"/></g><path d="M10.142,18l3.717-3.709L17.575,18l1.142-1.142L13.858,12,9,16.858Z" transform="translate(-5.858 -7)" fill="#6b7280"/></svg>;
}